import { Controller, FieldValues, Path, PathValue } from 'react-hook-form';
import { Box, InputAdornment, InputLabel, TextField, useMediaQuery, useTheme } from '@mui/material';
import { ITextInput } from './formTypes';
import { useGetErrorMessage } from '@retail/form/validation';

export const TextInput = <TFieldValues extends FieldValues>({
  name,
  label,
  required = false,
  disabled = false,
  readOnly = false,
  placeholder,
  margin = 'none',
  // @ts-ignore
  defaultValue = '' as PathValue<TFieldValues, Path<TFieldValues>>,
  size = 'medium',
  variant,
  startIcon,
  endIcon,
  control,
  ...rest
}: ITextInput<TFieldValues>) => {
  const { breakpoints } = useTheme();
  const isLessThanMedium = useMediaQuery(breakpoints.down('md'));
  const getErrorMessage = useGetErrorMessage();

  return (
    <Controller
      render={function ({ field, fieldState: { error } }) {
        return (
          <Box>
            {label && (
              <InputLabel htmlFor={name} required={required}>
                {label}
              </InputLabel>
            )}
            <TextField
              {...field}
              fullWidth={isLessThanMedium || rest.fullWidth}
              margin={margin}
              type="text"
              id={name}
              disabled={disabled}
              required={required}
              placeholder={placeholder}
              variant={variant}
              error={!!error}
              helperText={!!error && getErrorMessage(error['message'])}
              slotProps={{
                htmlInput: { readOnly },
                input: {
                  startAdornment: startIcon && (
                    <InputAdornment position="start">{startIcon}</InputAdornment>
                  ),
                  endAdornment: endIcon && (
                    <InputAdornment position="end">{endIcon}</InputAdornment>
                  ),
                  'aria-label': rest['aria-label'],
                },
              }}
              autoComplete="off"
              size={size}
            />
          </Box>
        );
      }}
      control={control}
      name={name}
      defaultValue={defaultValue}
    />
  );
};
